import { ImageUp, Plus, X } from "lucide-react";
import Button from "../../../../components/ui/Button";
import Input from "../../../../components/ui/Input";

function ClientDetails({
  proposalSettings,
  setProposalSettings,
  handleGenerateDescriptionsClick,
  isLoadingDescriptions,
  handleUploadLogo,
}) {
  const handleContactChange = (e, index) => {
    const { name, value } = e.target;
    console.log(name, value);
    const newContactPersons = [...proposalSettings.contactPersons];
    newContactPersons[index][name] = value;
    setProposalSettings({
      ...proposalSettings,
      contactPersons: newContactPersons,
    });
  };

  const addContact = () => {
    setProposalSettings({
      ...proposalSettings,
      contactPersons: [
        ...proposalSettings.contactPersons,
        { name: "", email: "", role: "" },
      ],
    });
  };

  const handleDeleteContact = (index) => {
    const newContactPersons = proposalSettings.contactPersons.filter(
      (_, i) => i !== index
    );
    setProposalSettings({
      ...proposalSettings,
      contactPersons: newContactPersons,
    });
  };

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex justify-between align-baseline py-2 flex-col">
        <h2 className="text-xl mb-8 mt-8 text-md text-start font-semibold text-slate-600">
          Client details
        </h2>
        <div className="bg-white shadow-sm rounded-3xl mt-5 p-5 border border-slate-200">
          <div className="p-2 rounded-xl mt-1">
            <div className="flex">
              <div>
                <div class="flex items-center w-full mb-5">
                  <label
                    for="dropzone-file"
                    class="flex flex-col items-center justify-center w-28 h-28 border border-slate-300 border-dashed rounded-2xl cursor-pointer bg-white dark:bg-gray-700 hover:bg-gray-100 hover:border-blue-700 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                  >
                    {proposalSettings.logoFile ? (
                      <img
                        src={URL.createObjectURL(proposalSettings.logoFile)}
                        alt="logo"
                        className="w-28 h-28 rounded-2xl object-contain p-1"
                      />
                    ) : (
                      <div class="flex flex-col items-center justify-center pt-5 pb-6">
                        <ImageUp
                          strokeWidth={1.2}
                          className="w-8 h-8 mt-5"
                          color="#a2a2a2"
                        />
                        <p class="mb-2 text-sm text-gray-400 dark:text-gray-400 mt-1">
                          Client logo
                        </p>
                      </div>
                    )}
                    <input
                      onChange={handleUploadLogo}
                      id="dropzone-file"
                      type="file"
                      class="hidden"
                    />
                  </label>
                </div>
              </div>
              <div className="ml-8 flex-1">
                <Input
                  label="Client Name"
                  placeholder="Client Name"
                  className="w-full p-3 mb-4 border border-slate-200"
                  value={proposalSettings.client}
                  onChange={(e) =>
                    setProposalSettings({
                      ...proposalSettings,
                      client: e.target.value,
                    })
                  }
                />
                <Input
                  label="Client Industry"
                  placeholder="Client Industry"
                  className="w-full p-3 mb-4 border border-slate-200"
                  value={proposalSettings.industry}
                  onChange={(e) =>
                    setProposalSettings({
                      ...proposalSettings,
                      industry: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="flex gap-4 items-center mb-2 mt-4">
              <p className="text-left text-sm mb-1 font-medium text-slate-600">
                Client Contact Persons
              </p>
              <Button
                className="inline-block w-fit ml-auto"
                type="ghost"
                size="small"
                startIcon={<Plus className="w-5" />}
                onClick={addContact}
              >
                Add Contact
              </Button>
            </div>
            <div className="flex gap-4 flex-col max-h-96 overflow-auto p-4 bg-slate-100 rounded-lg shadow-inner">
              {proposalSettings.contactPersons.map((contact, index) => (
                <div className="p-4 border-2 border-slate-100 rounded-2xl bg-white relative">
                  <div>
                    <p className="text-xs -mt-2 py-1 text-left text-slate-600 font-semibold mb-4">
                      Contact {index + 1}
                    </p>
                    <X
                      onClick={() => handleDeleteContact(index)}
                      color="#3f3f3f"
                      className="absolute top-2 right-2 opacity-50 hover:opacity-100 cursor-pointer"
                    />
                  </div>
                  <Input
                    label="Contact Name"
                    className="w-full p-3 mb-4 border border-slate-200"
                    value={contact.name}
                    name="name"
                    onChange={(e) => handleContactChange(e, index)}
                  />
                  <Input
                    label="Contact Email"
                    className="w-full p-3 mb-4 border border-slate-200"
                    value={contact.email}
                    name="email"
                    onChange={(e) => handleContactChange(e, index)}
                  />
                  <Input
                    label="Contact Role"
                    className="w-full p-3 border border-slate-200"
                    value={contact.role}
                    name="role"
                    onChange={(e) => handleContactChange(e, index)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <Button
          onClick={handleGenerateDescriptionsClick}
          className="inline-block mt-4 w-fit ml-auto"
          disabled={isLoadingDescriptions}
        >
          Generate Outline
        </Button>
      </div>
    </div>
  );
}

export default ClientDetails;
